import React from "react";
import { connect } from "react-redux";
import { Form, Card, Col } from 'react-bootstrap';
import PropTypes from "prop-types";

import { deepEqual } from "../../utils/object";

import Biography from "./biography";

import ConditionalButton from "../../layout/conditional-button";

import { me as myPersonRecord, mine as saveMyPersonRecord } from "../../actions/people";
import { send as pageInfo, loading } from "../../actions/pages";
import { send as sendAlert } from "../../actions/alerts";

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            person: {},
            errors: {},
            saving: false
        };
        
    }

    componentDidUpdate = (oldProps) => {
        if (!deepEqual(oldProps.person, this.props.person) && !deepEqual(this.props.person, this.state.person)) {
            this.setState({
                person: this.props.person
            });
        }
    }

    componentDidMount = async () => {
        setTimeout(() => {
            this.loadData();
        }, 30);
    }

    loadData = async () => {
        this.props.loading(true);

        try {
            const person = await this.props.myPersonRecord();
            this.setState({
                person: { ...(person || {}) }
            });
            await this.props.pageInfo({ title: "My Profile", breadcrumb: "Me" });
        } finally {
            this.props.loading(false);
        }
    }

    onPersonChange = (value, errors) => {
        this.setState((prev) => ({
            person: {
                ...(prev.person || {}),
                ...(value || {})
            },
            errors: errors || {}
        }));
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.onSaveClick(e);
    };

    onSaveClick = async (e) => {
        if (e?.preventDefault) e.preventDefault();
        if (this.state.saving) return;

        this.setState({ saving: true });
        this.props.loading(true);

        try {
            const personPayload = { ...(this.state.person || {}) };
            const personResponse = await this.props.saveMyPersonRecord(personPayload);
            const { success, ...savedPerson } = personResponse || {};

            if (!success) {
                this.props.sendAlert("Unable to save your profile.", "error");
                return;
            }

            this.setState({ person: { ...savedPerson } });
            this.props.sendAlert("Profile saved.", "success");
        } finally {
            this.setState({ saving: false });
            this.props.loading(false);
        }
    }    

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Save my profile" display={true} enabled={!this.state.saving} onEnabledClick={this.onSaveClick} icon="save">
                        {this.state.saving ? "Saving..." : "Save"}
                    </ConditionalButton>
                </Col>

                <Col md="12">
                    <Form className="client-profile-form" name="frm" method="post" onSubmit={this.onSubmit}>
                        <Card body className="mb-5">
                            <Biography {...this.state.person} onChange={this.onPersonChange} />
                        </Card>
                    </Form>
                </Col>
            </>
        )
    }
}

Profile.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps, { myPersonRecord, saveMyPersonRecord, pageInfo, loading, sendAlert })(Profile);
